// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"2050d18b","182":"2bbfee0b","508":"2a01632a","629":"584fea2a","745":"a4e0d51a","851":"71c18565"}[chunkId] + ".chunk.js";
};